// Shared UI constants for consistent dimensions across components
export const UI_CONSTANTS = {
  NAVIGATION_DRAWER_WIDTH: 256,
} as const;
